import React, { useEffect } from 'react';
import { useAuth } from "../context/AuthProvider";
import { useNavigate } from 'react-router-dom'

const HomePage: React.FC = () => {
    const navigate = useNavigate();
    const { authenticated, login, logout, token } = useAuth();
    
    useEffect(() => {
      if (authenticated) {
        navigate('/');  // Si l'utilisateur n'est pas authentifié, redirige vers la page home
      } 
    }, [authenticated]);

  return (
    <div>
      
      
     

      
    </div>
  );
};

export default HomePage;
